import { Typography } from "@mui/material";
import { KeyConstant, LangConstant } from "const";
import { memo, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { ConversationSelectors } from "redux-store";
import { createSelector } from "reselect";
import { StorageUtil } from "utils";
import { getNSLang } from "utils/lang.utils";
import orderBy from "lodash/orderBy";

const memoizedIncomingState = createSelector(
  [
    ConversationSelectors.getSelectedGroupId,
    ConversationSelectors.getThreadingId,
    state => state.conversationRedux.incomingMessages,
  ],

  (selectedGroupId, selectedThreadId, incomingMessages) => {
    const accountId = StorageUtil.getItem(KeyConstant.KEY_ACCOUNT_ID);

    const newMessageObj = Boolean(selectedThreadId)
      ? incomingMessages[selectedThreadId]
      : incomingMessages[selectedGroupId];

    const messageList = newMessageObj ? Object.values(newMessageObj) : null;

    if (Array.isArray(messageList) && messageList.length > 0) {
      const receivedMessages = messageList.filter(
        item => item.senderId !== accountId && false === Boolean(item.parentId),
      );
      const orderMessage = orderBy(receivedMessages, ["created"], ["desc"]);
      return orderMessage[0];
    }

    return null;
  },
);

const ScrollTooltip = ({ isShowButton }) => {
  const newMessage = useSelector(memoizedIncomingState);

  const [isShow, setIsShow] = useState(true);

  // Show notification "Has new message" when has new message in current mode
  // Except case: reply on delete only me message
  useEffect(() => {
    if (newMessage && !newMessage.isDeleteOnlyMe) setIsShow(Boolean(isShowButton));
  }, [newMessage]);

  useEffect(() => {
    if (!isShowButton) setIsShow(false);
  }, [isShowButton]);

  return isShow ? (
    <Typography className="custom-notice" color="primary">
      {getNSLang(LangConstant.NS_HOME, "TXT_HAS_NEW_MESSAGE")}
    </Typography>
  ) : (
    <></>
  );
};

export default memo(ScrollTooltip);
